import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className = '',
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-219">
      {children}
    </MotionTag>;
}